import {Button} from "react-bootstrap";
import {useState} from "react";


function RoverPathGeneration( {waterSourceLatLng, referencePath, onGeneratePathsClicked, onExportClicked, onFinishClicked} ) {

    const [firstOffset, setFirstOffset] = useState(3 * 21);
    const [offset, setOffset] = useState(42);
    const [referenceSmoothing, setReferenceSmoothing] = useState(1.5);
    const [angle, setAngle] = useState(70);
    const [minDistServicePath, setMinDistServicePath] = useState(20);
    const [servicePathPull, setServicePathPull] = useState(0.7);


    const onFirstOffsetChanged = (event) => {
        let value = Math.max(1, parseInt(event.target.value));
        setFirstOffset(value);
        onGeneratePathsClicked(value, offset, referenceSmoothing, angle, minDistServicePath, servicePathPull);
    };

    const onOffsetChanged = (event) => {
        let value = Math.max(1, parseInt(event.target.value));
        setOffset(value);
        onGeneratePathsClicked(firstOffset, value, referenceSmoothing, angle, minDistServicePath, servicePathPull);
    };

    const onSmoothingChanged = (event) => {
        let value = Math.max(0, parseFloat(event.target.value));
        setReferenceSmoothing(value);
        onGeneratePathsClicked(firstOffset, offset, value, angle, minDistServicePath, servicePathPull);
    };

    const onAngleChanged = (event) => {
        let value = Math.max(0, parseFloat(event.target.value));
        setAngle(value);
        onGeneratePathsClicked(firstOffset, offset, referenceSmoothing, value, minDistServicePath, servicePathPull);
    };
    const onServicePathDistChanged = (event) => {
        let value = Math.max(0, parseFloat(event.target.value));
        setMinDistServicePath(value);
        onGeneratePathsClicked(firstOffset, offset, referenceSmoothing, angle, value, servicePathPull);
    };
    const onServicePathPullChanged = (event) => {
        let value = Math.max(0, parseFloat(event.target.value));
        setServicePathPull(value);
        onGeneratePathsClicked(firstOffset, offset, referenceSmoothing, angle, minDistServicePath, value);
    };

    const onSubmit = () => { onGeneratePathsClicked(firstOffset, offset, referenceSmoothing, angle, minDistServicePath, servicePathPull)};
    const onExport = () => { onExportClicked()};

    return (
        <div className={"container"}>
            <form>
                <div className={"row"}>
                    <div className={"col"}>1st&nbsp;offset:</div>
                    <div className={"col"}>
                        <input type={"number"} defaultValue={firstOffset} step={1} onChange={event => onFirstOffsetChanged(event)}/>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col"}>Offsets</div>
                    <div className={"col"}>
                        <input type={"number"} defaultValue={offset} step={1} onChange={event => onOffsetChanged(event)}/>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col"}>AB&nbsp;Smoothing</div>
                    <div className={"col"}>
                        <input type={"number"} defaultValue={referenceSmoothing} step={0.5} onChange={event => onSmoothingChanged(event)}/>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col"}>Corner&nbsp;angle</div>
                    <div className={"col"}>
                        <input type={"number"} defaultValue={angle} step={10} onChange={event => onAngleChanged(event)}/>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col"}>Service Path Distance</div>
                    <div className={"col"}>
                        <input type={"number"} defaultValue={minDistServicePath} step={1} onChange={event => onServicePathDistChanged(event)}/>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col"}>Service Path Straightness</div>
                    <div className={"col"}>
                        <input type={"number"} defaultValue={servicePathPull} step={0.1} onChange={event => onServicePathPullChanged(event)}/>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col offset-1"}><Button onClick={onSubmit}>Generate Paths</Button></div>
                </div>
                <div className={"row"}>
                    <div className={"col offset-1"}><Button onClick={onExport}>Export KML</Button></div>
                </div>
                <div className={"row"}>
                    <div className={"col offset-1"}><Button onClick={onFinishClicked}>Start Planning</Button></div>
                </div>
            </form>
        </div>
    );


}


export default RoverPathGeneration;
